import maplibregl from 'maplibre-gl'

export const appName = process.env.REACT_APP_NAME
export const domain = process.env.REACT_APP_MODE === 'private' ? 'shizuoka-syokuin.riskma.jp' : 'shizuoka.riskma.jp'

export const cognitoConfig = {
  Region: 'ap-northeast-1',
  UserPoolId: 'ap-northeast-1_o2N10jDWa',
  ClientId: '300338d7od17geon76ncvekkg2',
}

export const defaltMapPayload = {
  center: new maplibregl.LngLat(138.434, 35.018),
  zoom: 12,
  bounds: new maplibregl.LngLatBounds(
    new maplibregl.LngLat(
      138.0849,
      34.7132
    ), new maplibregl.LngLat(
      138.8767,
      35.2310
    )
  )
}

export const mlitRiverCityRegion = '2201100'
